export default __webpack_public_path__ + "static/media/054-money.569984a4.svg";